// extracted by mini-css-extract-plugin
export default {"qr-code-generation":"faqs_qr-code-generation__Vi47R","faqs":"faqs_faqs__zimV1","faq-blocks":"faqs_faq-blocks__wIjor","faq-question":"faqs_faq-question__lYxq8"};